export const formatNumber = (value) => {
  if (typeof value !== 'number') return value
  
  const rounded = Math.round(value * 100) / 100
  
  if (rounded === Math.floor(rounded)) {
    return Math.floor(rounded)
  }
  
  return +rounded.toFixed(2)
}

export const formatNumberWithUnits = (value) => {
  if (typeof value !== 'number') return value
  
  const rounded = Math.round(value * 100) / 100
  
  if (rounded >= 1000000) {
    const millions = rounded / 1000000
    return millions === Math.floor(millions) ? `${Math.floor(millions)}M` : `${millions.toFixed(1)}M`
  }
  
  if (rounded >= 1000) {
    const thousands = rounded / 1000
    return thousands === Math.floor(thousands) ? `${Math.floor(thousands)}K` : `${thousands.toFixed(1)}K`
  }
  
  if (rounded === Math.floor(rounded)) {
    return Math.floor(rounded)
  }
  
  return +rounded.toFixed(2)
}